import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfigurableGridComponent, GridConfig } from '../configurable-grid/configurable-grid.component';
import { MasterDataService } from '../../../Services/master-data.service';
import { BaseInspectionOverview } from 'src/app/DTOs/InspectionMasterData/productDetailModel';

@Component({
  selector: 'app-documents',
  standalone: true,
  imports: [CommonModule, ConfigurableGridComponent],
  templateUrl: './documents.component.html',
  styleUrl: './documents.component.css'
})
export class DocumentsComponent {
  gridConfig: GridConfig;

  constructor(private masterData: MasterDataService) {
    this.gridConfig = {
      getData: () => this.masterData.getDocumentsOverview(),
      createItem: (item: BaseInspectionOverview) => this.masterData.createDocuments(item),
      updateItem: (id: number, item: BaseInspectionOverview) => this.masterData.updateDocuments(item.databaseId, item),
      deleteItem: (id: number) => this.masterData.deleteDocument(id)
    };
  }
}